import React, { useContext } from 'react';
import CaseListWrapper from './CaseListWrapper';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { KatAlert } from '@amzn/katal-react';
import {
  APP_CONTAINER_BASE_URL,
  PROGRAM_ACCOUNTS,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import { AuthConstants } from 'src/constants/ProjectConstants';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { logger } from 'src/logger';

const CaseList = () => {
  const userContext = useContext(AuthContext);
  const { messageBundle } = useContext(TranslationContext);
  const description = messageBundle.formatMessage(
    AuthConstants.NO_ACCOUNT_MAPPING,
    {
      loginId: userContext.customerId,
    },
  );
  const externalPortalDescription = messageBundle.formatMessage(
    AuthConstants.NO_ACCOUNT_MAPPING_IN_EXTERNAL_PORTAL,
    {
      loginId: userContext.customerId,
    },
  );

  logger.info(`UserContext is:  ${JSON.stringify(userContext)}`);
  //If the preferred account is sustainability, then page mapping should be sustainability else regulator central
  const isValidPageMapping =
    PROGRAM_ACCOUNTS.SUSTAINABLITY === userContext.preferredAccountId
      ? userContext.appContainerBaseUrl === APP_CONTAINER_BASE_URL.HRECOMPLAINTS
      : userContext.appContainerBaseUrl ===
        APP_CONTAINER_BASE_URL.REGULATOR_CENTRAL;
  const isRegulatorCentralApp =
    userContext.clientId === UI_CLIENTS.RegulatorCentral;

  //Users should be shown an error message if there are no accounts mapped to the account
  //or if the app is external and the page is invalid.
  if (
    (userContext && userContext.accountAttributes.length === 0) ||
    (isRegulatorCentralApp && !isValidPageMapping)
  ) {
    if (userContext.clientId === UI_CLIENTS.VICI) {
      return (
        <KatAlert
          data-testid="error_message_listcase_vici"
          persistent
          variant="danger"
          description={description}
        />
      );
    } else {
      return (
        <KatAlert
          data-testid="error_message_listcase_regulatorcentral"
          persistent
          variant="danger"
          description={externalPortalDescription}
        />
      );
    }
  }
  return <CaseListWrapper />;
};

export default CaseList;
